/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA
 */

import pageController from '@/core/page/page';
import ErrorScreen from '@/component/error/errorScreen/ErrorScreen.svelte';
import { __ } from '@oat-sa-private/ui-core';

export default () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pageController({
        name: 'error',

        /**
         * Error controller
         *
         * It can be called in 2 ways, either internally with a JavaScript Error (internalError)
         * or using LTI parameters
         *
         * @param {Object} params - parameters from the dispatched URL
         * @param {string} [params.lti_errormsg] - Error message to display
         * @param {string} [params.lti_errorlog] - Error message to log
         * @param {string} [params.lti_errortitle] - Title to display on the error page
         */
        start({ lti_errormsg, lti_errorlog, lti_errortitle }) {
            if (lti_errorlog) {
                /*eslint-disable no-console*/
                console.log(lti_errorlog);
            }
            this.component = new ErrorScreen({
                target: this.container,
                props: {
                    title: lti_errortitle || __('Internal server error'),
                    info: lti_errormsg || __('Your session ID has expired. Try to refresh the page or contact the system administrator.')
                }
            });
        }
    });
